import FileSaver from 'file-saver';
import {defineConfig} from '../config'
import { authHeader } from '../helpers';
import { utilsService } from './utils'
const {handleResponse, handleResponseBlob} = utilsService

export const systemsService = {
  getApiPath,
  getAllSystems,
  getAllFrames,
  getAllSystemsByType,
  getAllTypeSystems,
  getAllSizeSystems,
  getAllSystemsByArea,
  getAllSystemsByBounds,
  getAllSystemsPaginatedByArea,
  getAllSystemsDoohByArea,
  getAllSystemsUnassociatedByType,
  getAllMediaOwners,
  getAllAreaSystems,
  getAllMunicipalities,
  createSystem,
  getSizeById,
  getSystemById,
  getSystemsByIds,
  getFramesBySystemId,
  downloadSystemTemplate,
  updateSystem,
  deleteSystem,
  importSystems,
  getAllSystemTypes,
  getAllSystemTypesByType,
  deleteDomainsSystem,
  getPreviewId,
  getAllLease,
  getAllAuthorizations,
  getLocationsByAddress,
  uploadImage,
  deleteImage,
  getSystemSuggestions,
  getImage,
  getImageBySystemId,
  getMunicipalityById,
  advancedFilterSystems,
  getAllLocations,
  getSystemTypeDimensions,
  createSystemTypeDimensions,
  getSystemSuggestionsNoPagination,
  getAllSystemTeamManagementsPaged,
  getAllSystemTeams,
  getSystemTeamById,
  updateSystemTeam,
  createSystemTeam,
  deleteSystemTeam,
  upsertSystemTeamManagement,
  getSystemTeamManagementDuties,
  deleteSystemTeamManagement,
  getSystemTeamManagementsBySystem,
};

const { apiUrl, apiVer } = defineConfig.SYSTEMS_SERVICE;

function getApiPath(){
  const version = (apiVer !== null ? ("/" + apiVer) : "");
  return (apiUrl + version);
}

function getAllSystems() {
  const url = getApiPath() + "/system/all/";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  
  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllFrames(systemId) {
  const url = getApiPath() + `/system/getSystemFrameBySystemId?systemId=${systemId}`;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllSystemsByType(type) {
  const url = getApiPath() + "/system/all/" + type;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllTypeSystems(type) {
  const url = getApiPath() + "/system/type/all" + "?type=" + type;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllMediaOwners() {
  const url = getApiPath() + "/mediaOwner/all";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getFramesBySystemId(systemId){
  const url = getApiPath() + "/system/getSystemFrameBySystemId?systemId=" + systemId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllSizeSystems(type) {
  const url = getApiPath() + "/size/all?type=" + type;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemsByIds(ids){
  const url = getApiPath() + "/system/getAllByIds";
  
  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(ids)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}


function getAllSystemsByArea(cid, type) {
  const url = getApiPath() + "/system/area/list?cid=" + cid + "&type=" + type;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllSystemsByBounds(bounds, category) {
  const url = getApiPath() + `/system/inAreaList?type=${category}&biasPercentage=0.010`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(bounds)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllSystemsPaginatedByArea( page = 0, perPage = 10, searchTerm = "", type = "") {
  let url = "";
  if(searchTerm == null){
    url = getApiPath() + "/system/all/page/" + page + "/perPage/" + perPage + "?type=" + type + "&searchTerm=" + searchTerm ;
  }
  else{
    url = getApiPath() + "/system/all/page/" + page + "/perPage/" + perPage + "?type=" + type ;
  }

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllSystemsDoohByArea() {
  const url = getApiPath() + "/system/all/?type=DOOH";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllSystemsUnassociatedByType(type = "OOH") {
  const url = getApiPath() + "/system/area/listDto/all?noCircuit=true&type=" + type;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllMunicipalities() {
  const url = getApiPath() + "/system/getMunicipalities";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllAreaSystems() {
  const url = getApiPath() + "/system/area/all";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemById(id) {
  const url = getApiPath() +"/system/id/"+ id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function updateSystem(system) {
  const url = getApiPath() + "/system/update?id=" + system.id + "&type=" + system.type;
  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(system)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}
function createSystem(system) {
  const {type} = system;
  const url = getApiPath() + "/system/create?type=" + type;
  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(system)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function deleteSystem(systemId) {
  const url = getApiPath() + "/system/delete?id=" + systemId;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function importSystems(file) {
  const url = getApiPath() + "/system/upload";
  const formData = new FormData();
  formData.append("file", file);

  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: formData
  };

  return fetch(
    url,
    requestOptions
  )
  .then(handleResponse)
  .then(res => {
    return res;
  });
}

function getAllSystemTypesByType(type = 'OOH') {
  const url = getApiPath() +"/system/systemType/getByType?type=" + type;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllSystemTypes() {
  const url = getApiPath() +"/system/systemType/getAll";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function downloadSystemTemplate() {
  const url = getApiPath() + "/system/download/templateImportSystems";

  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    url,
    requestOptions
  )
  .then((response) => response.blob())
  .then((blob) => FileSaver.saveAs(blob, 'template_impianti.xlsx'))
}


function deleteDomainsSystem(systemId, domains, type) {
  const url = getApiPath() + "/system/" + systemId + "/domains" + type;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
    body: JSON.stringify({domains: domains})
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}


function getSizeById(idSize, type) {
  const url = getApiPath() +"/size/byId?sid="+ idSize + "&type=" + type;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}



function getPreviewId(type){
  const url = getApiPath() +"/system/getPreviewId?sequenceName=" + type;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllLease(){
  const url = getApiPath() +"/system/lease/all";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllAuthorizations(){
  const url = getApiPath() +"/system/authorization/all";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getLocationsByAddress(address){
  const url = getApiPath() +"/geocode/getGeocodeLocations?address=" + address;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllSystemTeams(){
  const url = apiUrl + "/v2/system/team/all" ;
  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllSystemTeamManagementsPaged(page, perPage, companyName = '', address = '', vat = '', mail = '', type = [], phone = '', sortOrder='ASC'){
  const url = apiUrl + "/v2/system/team/all/page/" + page + "/perPage/" + perPage ;

  const body = {
    companyName: companyName, 
    address: address, 
    vat : vat, 
    SystemTeamManagementType : type,
    mail : mail, 
    phone : phone, 
    sortOrder: sortOrder
  }

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body:JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemTeamById(id){
  const url = apiUrl + "/v2/system/team/" + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function updateSystemTeam(body, id){
  const url = apiUrl +"/v2/system/team/update/" + id;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function createSystemTeam(body){
  const url = apiUrl +"/v2/system/team/create";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function deleteSystemTeam(id){
  const url = apiUrl + "/v2/system/team/delete/" + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function upsertSystemTeamManagement(body){
  const url = apiUrl +"/v2/system/team/management/upsert";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemTeamManagementDuties(){
  const url = apiUrl + "/v2/system/team/duties";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemTeamManagementsBySystem(systemId){
  const url = apiUrl + "/v2/system/team/management/systemId/" + systemId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function assignSystemTeamManagementToSystem(systemId, SystemTeamManagementId){
  const url = getApiPath() +"/team/systemSystemTeamManagement/create";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(
      {
        systemId: systemId,
        teamId: SystemTeamManagementId,
        duties:null
      }
    )
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function deleteSystemTeamManagement(systemTeamManagementId){
  const url = apiUrl +"/v2/system/team/management/delete/" + systemTeamManagementId;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function updateSystemSystemTeamManagement(systemSystemTeamManagementId, body){
  const url = getApiPath() +"/team/systemSystemTeamManagement/update/" + systemSystemTeamManagementId;

  const requestOptions = {
    method: "PUT",
    headers: authHeader("application/json"),
    body: JSON.stringify(body)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

 function uploadImage (file) {
  const url = getApiPath() + "/system/image/upload";
  const formData = new FormData();

  formData.append('file', file);

  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: formData
  };

  return fetch(
    url,
    requestOptions
  )
  .then(handleResponse)
  .then(res => {
    return res;
  });
};

function getImage(id) {
  const url = getApiPath() + "/system/image/get/" + id;
  
  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };
  return fetch(
    url,
    requestOptions
  )
  .then(handleResponseBlob)
  .then(blob => URL.createObjectURL(blob))
  .then(res => {
    return res;
  });
}

function getImageBySystemId(systemId) {
  const url = getApiPath() + "/system/image/" + systemId + "/systemId";
  
  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };
  return fetch(
    url,
    requestOptions
  )
  .then(handleResponseBlob)
  .then(blob => URL.createObjectURL(blob))
  .then(res => {
    return res;
  });
}

function deleteImage(id) {
  const url = getApiPath() + "/system/image/delete/" + id;

  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  return fetch(
    url,
    requestOptions
  )
  .then(handleResponse)
  .then(res => {
    return res;
  });
};

function getMunicipalityById(id) {
  const url = getApiPath() + "/system/getMunicipalityById?municipalityId=" + id;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function advancedFilterSystems(selectedFilters, systemCategory) {
  const url = getApiPath() + "/system/search/params?page=0&size=9999&type=" + systemCategory;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(selectedFilters)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getAllLocations(searchText) {
  const url = getApiPath() + "/system/" + searchText + "/distinct";

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemSuggestions(searchTerm, searchField, page = 0, size = 20, sortBy = "creationDate", sortDir = "descend", type = "ALL", filters = {}) {
  const url = apiUrl + "/v2" + `/system/suggestion?searchTerm=${encodeURIComponent(searchTerm)}&searchField=${searchField}&page=${page}&size=${size}&sortBy=${sortBy}&sortDir=${sortDir}&type=${type}`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(filters)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemSuggestionsNoPagination(searchTerm, searchField, sortBy = "creationDate", sortDir = "descend", type = "ALL", filters = {}) {
  const url = apiUrl + "/v2" + `/system/suggestion/map?searchTerm=${encodeURIComponent(searchTerm)}&searchField=${searchField}&sortBy=${sortBy}&sortDir=${sortDir}&type=${type}`;

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(filters)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function getSystemTypeDimensions(typeId) {
  const url = getApiPath() + "/system/systemType/dimension/" + typeId;

  const requestOptions = {
    method: "GET",
    headers: authHeader("application/json"),
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}

function createSystemTypeDimensions(dimension) {
  const url = getApiPath() + "/system/systemType/dimension/create";

  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(dimension)
  };

  return fetch(
    url,
    requestOptions
  )
    .then(handleResponse)
    .then(res => {
      return res;
    });
}